export function formatDate(dateString) {
    const date = new Date(dateString);
  
    return date
      .toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      })
      .replace(',', '   ');
}

// helper to safely format dates for <input type="date" />
export const formatInputDate = (date) => {
  if (!date) return "";
  return new Date(date).toISOString().split("T")[0];
};